import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5 12C5 8.13401 8.13401 5 12 5C14.3931 5 16.5072 6.20099 17.7701 8.03535L15.9808 7.76248C15.4348 7.67922 14.9247 8.05432 14.8415 8.60029C14.7582 9.14626 15.1333 9.65636 15.6793 9.73962L19.8734 10.3792C20.4194 10.4625 20.9295 10.0874 21.0128 9.54144L21.6524 5.34729C21.7357 4.80132 21.3606 4.29122 20.8146 4.20796C20.2686 4.12469 19.7585 4.49979 19.6753 5.04577L19.3968 6.87181C17.7722 4.53286 15.0659 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C15.3325 21 18.2407 19.1882 19.7953 16.5007C20.0719 16.0227 19.9085 15.4109 19.4305 15.1344C18.9524 14.8579 18.3407 15.0212 18.0641 15.4993C16.8523 17.5942 14.5897 19 12 19C8.13401 19 5 15.866 5 12Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.13 8.065C3.13 5.3255 5.28989 3.13 7.92343 3.13C9.39835 3.13 10.7218 3.81598 11.6038 4.90297L10.1022 4.80972C9.79076 4.79038 9.52261 5.02717 9.50327 5.33861C9.48393 5.65005 9.72072 5.9182 10.0322 5.93754L12.8642 6.11342C13.0144 6.12274 13.1621 6.07178 13.2746 5.97181C13.3871 5.87185 13.455 5.73115 13.4634 5.58091L13.6211 2.74777C13.6385 2.43621 13.3999 2.16958 13.0884 2.15223C12.7768 2.13489 12.5102 2.37339 12.4929 2.68495L12.4136 4.10914C11.3299 2.82084 9.72225 2 7.92343 2C4.63821 2 2 4.72937 2 8.065C2 11.4006 4.63821 14.13 7.92343 14.13C10.124 14.13 12.0372 12.9022 13.0572 11.0924C13.2104 10.8206 13.1142 10.476 12.8424 10.3228C12.5706 10.1696 12.226 10.2658 12.0728 10.5376C11.2398 12.0157 9.68966 13 7.92343 13C5.28989 13 3.13 10.8045 3.13 8.065Z"
  />
);

export const RefreshIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Refresh" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
